import firebase from 'firebase';
import 'firebase/firestore';

firebase.initializeApp(
  { apiKey            : "AIzaSyCqwB7C3LH4QhDat968unngi3DRYsUL_dM"
  , authDomain        : "area-chat-d74ed.firebaseapp.com"
  , databaseURL       : "https://area-chat-d74ed.firebaseio.com"
  , projectId         : "area-chat-d74ed"
  , storageBucket     : "area-chat-d74ed.appspot.com"
  , messagingSenderId : "814266646530"
  }
)

const firestore = firebase.firestore();
const settings = { timestampsInSnapshots: true };
firestore.settings(settings);

export default firebase;



// WEBPACK FOOTER //
// ./src/firebase/index.js